import React from "react";
import { withRouter } from "react-router-dom";
import { useLastLocation } from "react-router-last-location";
import UserProfile from "../../../app/partials/layout/UserProfile";
import { toAbsoluteUrl } from "../../../_metronic";
import { connect } from "react-redux";
import * as aiChat from "../../../app/store/ducks/ai-chat.duck";
import * as dashboard from "../../../app/store/ducks/dashboard.duck";
import BetterButton from '../../../app/components/BetterButton';

class Topbar extends React.Component {
	render() {
		const { user, aiChat, dashboard, location, history, lastLocation } = this.props;

		const chatToggle = (e) => {
			e.preventDefault();

			this.props.toggleChat();
		};

		const handleBackClick = () => {
			if (dashboard.onBackClick) {
				dashboard.onBackClick();
			} else {
				const hasValidLastLocation = lastLocation && 
					lastLocation.pathname !== location.pathname && 
					lastLocation.pathname !== '/dashboard' && 
					lastLocation.pathname !== '/';
				
				if (hasValidLastLocation) {
					history.push(lastLocation.pathname);
				} else {
					// Caso contrário, usa o histórico do navegador
					// Se não houver histórico, o goBack() não fará nada
					history.goBack();
				}
			}
		};

		const isDashboardInitial = location.pathname === '/dashboard' || location.pathname === '/';
		const showBackButton = dashboard.expandedWidget || !isDashboardInitial;

		return (
			<div className={`kt-header__topbar ${showBackButton ? 'kt-header__topbar--with-back' : ''}`} style={{ zIndex: '-1' }}>
				{showBackButton && (
					<div className="kt-header__topbar-item kt-header__topbar-item--back desktop">
						<BetterButton 
							text="Voltar" 
							outline 
							colorType="primary" 
							icon="fa fa-arrow-left" 
							style={{ width: 100, height: 40 }} 
							onClick={handleBackClick}
						/>
					</div>
				)}

				<div className="kt-header__topbar-item kt-header__topbar-item--ai-user">
					{[1, 3].includes(user?.usu_id_empresa) ?
						<button className={`btn-ai-header ${aiChat.toggleChat ? 'active' : ''}`} onClick={(e) => chatToggle(e)}>
							<img src={toAbsoluteUrl("/images/ai/sparkles.svg")} alt="AI Chat" style={{ maxWidth: '100%', height: 'auto' }} />
						</button>
						: null
					}

					<UserProfile showAvatar={false} showHi={true} showBadge={false} />
				</div>
			</div>
		);
	}
}

const mapStateToProps = ({ auth: { user }, aiChat, dashboard }) => ({ user, aiChat, dashboard });

const TopbarWithLastLocation = (props) => {
	const lastLocation = useLastLocation();
	return <Topbar {...props} lastLocation={lastLocation} />;
};

export default withRouter(connect(mapStateToProps, { ...aiChat.actions, ...dashboard.actions })(TopbarWithLastLocation));